<template>
  <div class="app-container">
    <div class="screeBox">
      <el-input
        class="screenInput"
        v-model="screen.name"
        placeholder="请输入园区名称"
      ></el-input>
      <el-button
        size="medium"
        type="primary"
        @click="(screen.page = 1), fetchData()"
        >筛选</el-button
      >
    </div>
    <div style="margin-top: 20px">
      <el-button
        size="medium"
        type="primary"
        @click="addMenu(0)"
        v-if="roles.includes('/park/add')"
        >添加园区</el-button
      >
    </div>

    <el-table
      max-height="700"  v-loading="listLoading" 
      :data="list"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="园区名称" align="center">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="园区联系电话" align="center" width="150">
        <template slot-scope="scope">
          {{ scope.row.mobile }}
        </template>
      </el-table-column>
      <el-table-column label="对公账户银行" align="center" width="150">
        <template slot-scope="scope">
          {{ scope.row.bank_name }}
        </template>
      </el-table-column>
      <el-table-column label="对公账户卡号" align="center" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.bank_code }}</span>
        </template>
      </el-table-column>
      <el-table-column label="园区地址" align="center" width="200">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.address }}</div>
        </template>
      </el-table-column>
      <el-table-column label="园区纬度" align="center" width="90">
        <template slot-scope="scope">
          <span>{{ scope.row.lat }}</span>
        </template>
      </el-table-column>
      <el-table-column label="园区经度" align="center" width="90">
        <template slot-scope="scope">
          <span>{{ scope.row.lng }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="80" align="center">
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.role_type == 1 ? '后台' : '小程序' }}</span> -->
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
      <!-- <el-table-column class-name="status-col" label="Status" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="250"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="roles.includes('/park/info')"
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            >查看</el-button
          >
          <el-button
            v-if="roles.includes('/park/edit')"
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <!-- <el-button
            size="mini"
            type="danger"
            v-if="
              roles.includes('/park/del') && scope.row.id != userInfo.park_id
            "
            @click="handleDelete(scope.row.id)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="600px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="园区名称" prop="name">
          <el-input
            v-model="ruleForm.name"
            :disabled="cztype == 'see'"
            placeholder="请输入园区名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="园区联系电话" prop="mobile">
          <el-input
          maxlength="11"
            v-model="ruleForm.mobile"
            :disabled="cztype == 'see'"
            placeholder="请输入园区联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="园区地址" prop="address">
          <el-input
            v-model="ruleForm.address"
            :disabled="cztype == 'see'"
            placeholder="请输入园区地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="对公账户银行" prop="bank_name">
          <el-input
            v-model="ruleForm.bank_name"
            :disabled="cztype == 'see'"
            placeholder="请输入手对公账户银行"
          ></el-input>
        </el-form-item>
        <el-form-item label="对公账户卡号" prop="bank_code">
          <el-input
            v-model="ruleForm.bank_code"
            :disabled="cztype == 'see'"
            placeholder="请输入对公账户卡号"
          ></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="lat">
          <el-input
            v-model="ruleForm.lat"
            :disabled="cztype == 'see'"
            placeholder="请输入纬度"
          ></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="lng">
          <el-input
            v-model="ruleForm.lng"
            :disabled="cztype == 'see'"
            placeholder="请输入经度"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { parkList, addpark, editpark, delpark, parkInfo } from "@/api/index";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  computed: {
    ...mapGetters(["roles", "userInfo"]),
  },
  data() {
    return {
      total: 0,
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加园区",
      token: getToken(),
      screen: {
        page: 1,
        page_size: 15,
        name: "",
        id: "",
      },
      ruleForm: {
        name: "",
        mobile: "",
        address: "",
        bank_name: "",
        bank_code: "",
        lat: "",
        lng: "",
        status: 1,
      },
      rules: {
        name: [{ required: true, message: "请输入园区名称", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入园区联系电话", trigger: "blur" },
        ],
        address: [{ required: true, message: "园区地址", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      multipleSelection: [],
      cztype: "",
      oldImg: "",
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.id = this.userInfo.park_id;
    } else {
      this.screen.id = "";
    }
    this.fetchData();
  },
  methods: {
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then((_) => {
              editpark(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  if (this.oldImg) {
                    that.delImg(this.oldImg);
                  }
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch((_) => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = JSON.parse(JSON.stringify(val));
      // this.ruleForm.id = val.id;
      this.getInfo(val.id);
      this.oldImg = val.picture;
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val;
      this.getInfo(val.id);
      this.drawer = true;
    },
    getInfo(id) {
      parkInfo({ id: id }).then((res) => {
        this.ruleForm = {
          id: res.data.info.id,
          name: res.data.info.name,
          mobile: res.data.info.mobile,
          address: res.data.info.address,
          bank_name: res.data.info.bank_name,
          bank_code: res.data.info.bank_code,
          lat: res.data.info.lat,
          lng: res.data.info.lng,
          status: res.data.info.status,
        };
      });
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then((_) => {
          delpark({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then((_) => {
              addpark(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加园区";
      this.cztype = "add";
      this.ruleForm = {
        name: "",
        mobile: "",
        address: "",
        bank_name: "",
        bank_code: "",
        lat: "",
        lng: "",
        status: 1,
      };
      this.drawer = true;
    },
    delpark() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个用户");
        return;
      }
      this.$confirm("确认删除？")
        .then(() => {
          delpark({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      parkList(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
</style>
